































  import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator";
  import { namespace } from "vuex-class";
  import MaskAlarm from "./MaskAlarm.vue";
  import { MaskReason } from "@/store/site-monitor/types";

  const SiteMonitor = namespace("siteMonitor");

  @Component({
    components: {
      "maskAlarm": MaskAlarm
    }
  })
  export default class MaskAlarmDialog extends Vue {
    @SiteMonitor.Getter groupID!: number;
    @SiteMonitor.State('MaskReasons') maskReasons!: any[];
    @SiteMonitor.Action loadMaskReasonsForAlarmWithRegion: ({ groupID: number, regionURL: string }) => Promise<void>;
    @SiteMonitor.Action loadMaskedAlarms: any;

    public submitting = false;
    public responseID: number = null;
    public eventID: number = null;
    public maskedAlarm: any = null;

    $refs: {
      maskModal: any,
      maskAlarmControl: MaskAlarm
    }

    // == Methods == //
    public show(eventID: number, responseID: number, maskedAlarm: any) {
      if (!(this.maskReasons) || this.maskReasons.length == 0) {
        this.loadMaskReasonsForAlarmWithRegion({ groupID: this.groupID, regionURL: null });
      }

      this.eventID = eventID;
      this.responseID = responseID;
      this.maskedAlarm = maskedAlarm;
      
      this.$nextTick(() => (this.$refs.maskModal as any).show());
    }

    public close() {
		(this.$refs.maskModal as any).hide();
		(this.$refs.maskAlarmControl as any).reset();
    }

    public submit() {
		(this.$refs.maskAlarmControl as any).submit();
    }

    // == Control event handlers == //
    public onControlError(errorMessage) {}

    public onControlMaskedAlarm(result) {
      this.close();

      this.$nextTick(() => {
        this.loadMaskedAlarms(this.groupID);
      })
    }

    public onControlUnmaskedAlarm() {
      this.close();

      this.$nextTick(() => {
        this.loadMaskedAlarms(this.groupID);
      })
    }

    public onControlSubmitting(state) {
      this.submitting = state;
    }
  }
